package music.jammers.client.shared.event.track.presentation.viewmodel

import music.jammers.client.shared.event.track.presentation.model.UpdateInstrument
import music.jammers.shared.event.domain.model.EventMember
import music.jammers.shared.user.domain.model.User

data class EventTrackDetailsState(
    val progress: Boolean = false,
    val eventId: Long = 0,
    val eventTrackId: Long = 0,
    val artistName: String = "",
    val addedBy: User? = null,
    val trackTitle: String = "",
    val comment: String = "",
    val members: List<EventMember> = emptyList(),
    val selectedInstruments: List<UpdateInstrument> = emptyList(),
    val error: Throwable? = null,
    val deleteDialogOpened: Boolean = false,
    val user: User? = null,
    val confirmSignInTrack: EventMember? = null,
    val confirmSignOutTrack: EventMember? = null,
) {

    fun readyMembers(): List<EventMember> = members.filter { item ->
        item.status == EventMember.Status.BOOKED || item.status == EventMember.Status.BOOKED_OPTIONAL
    }

    fun requiredMembers(): List<EventMember> = members.filter { item ->
        item.status != EventMember.Status.BOOKED && item.status != EventMember.Status.BOOKED_OPTIONAL
    }

    fun isAdminOrOwner(): Boolean =
        user?.let {
            user.isAdmin || addedBy?.let { addedByUser ->
                user.id == addedByUser.id
            } ?: false
        } ?: false
}